import {
    CANCEL_BOOKING,
    CANCEL_BOOKING_SUCCESS,
    FETCH_BOOKING,
    FETCH_BOOKINGS,
    FETCH_BOOKINGS_FAILURE,
    FETCH_BOOKINGS_SUCCESS,
    FETCH_BOOKING_FAILURE,
    FETCH_BOOKING_SUCCESS,
    SORT_DESC,
    UPDATE_BOOKING_SUCCESS,
    BOOKINGS_LIST_FILTER_UPDATE,
    BOOKINGS_LIST_FILTER_CATEGORY,
    BOOKINGS_LIST_PAGE,
    BOOKINGS_LIST_SORT,
    AMEND_BOOKING,
    AMEND_BOOKING_SUCCESS,
} from 'store/actions/types';
import paginationHelper from 'helpers/pagination';
import reducerHelper from 'helpers/reducers';
import utils from 'helpers/utils';

const initialState = {
    data: {},
    field: 'created_at',
    filter: {},
    filterCategory: reducerHelper.FILTER_BASIC,
    ids: [],
    loading: false,
    offset: 0,
    order: SORT_DESC,
    page: 1,
    size: 24,
    total: 0,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case AMEND_BOOKING:
        case CANCEL_BOOKING:
        case FETCH_BOOKING:
        case FETCH_BOOKINGS:
            return Object.assign({}, state, {
                loading: true,
            });

        case FETCH_BOOKING_FAILURE:
        case FETCH_BOOKINGS_FAILURE:
            return Object.assign({}, state, {
                data: {},
                ids: [],
                loading: false,
                offset: 0,
                size: 0,
                total: 0,
            });

        case FETCH_BOOKING_SUCCESS:
            return Object.assign({}, state, {
                data: Object.assign({}, state.data, { [action.response.id]: action.response }),
                ids: [
                    ...state.ids,
                    ...action.response.id,
                ],
                loading: false,
            });

        case FETCH_BOOKINGS_SUCCESS:
            // Converts the Array of results to an Object based on the id.
            const convertResultsToData = utils.mapToObject(action.response.results, (value) => {
                return value.id;
            });

            const newIds = action.response.results.map(function (result) {
                return result.id;
            });

            return Object.assign({}, state, {
                data: Object.assign({}, state.data, convertResultsToData),
                ids: newIds,
                loading: false,
                offset: action.response.offset,
                size: action.response.size,
                total: parseInt(action.response.total, 10),
            });

        case AMEND_BOOKING_SUCCESS:
        case UPDATE_BOOKING_SUCCESS:
            return Object.assign({}, state, {
                data: Object.assign({}, state.data, {
                    [action.response.id]: action.response,
                }),
                loading: false,
            });

        case CANCEL_BOOKING_SUCCESS:
            return Object.assign({}, state, {
                data: Object.assign({}, state.data, {
                    [action.response.id]: action.response,
                }),
                loading: false,
            });

        case BOOKINGS_LIST_FILTER_CATEGORY:
            return Object.assign({}, state, {
                filterCategory: action.payload,
            });

        case BOOKINGS_LIST_PAGE:
            return Object.assign({}, state, {
                offset: paginationHelper.generateNewOffset(action.payload.page, state.size),
                page: action.payload.page,
            });

        case BOOKINGS_LIST_SORT:
            return Object.assign({}, state, {
                field: action.payload.field,
                order: action.payload.order,
            });

        case BOOKINGS_LIST_FILTER_UPDATE:
            const filteredValues = reducerHelper.normaliseState(initialState, action.payload);

            return Object.assign({}, state, filteredValues);

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/store/reducers/bookingsReducer.js